import { IIpOrganisationDto } from "../../core/authentication/ip-organisation.dto";
import { ITile } from "./tile.model";

export class OrganisationTile implements ITile {
  constructor(
    public key: string,
    public name: string,
    public base64Picture: string | null | undefined,
    public picture: string = "",
    public defaultImage: string = "./assets/images/school_icon.svg",
    public defaultImageClass: string = "blue-background",
    public imageClass: string = ""
  ) { }

  static fromDto(dto: IIpOrganisationDto): OrganisationTile {
    return new OrganisationTile(dto.Key, dto.Name, dto.Base64Picture);
  }
}
